export const setupDynamicSubMenu = (): void => {
  document.querySelectorAll<HTMLElement>("[data-dynamic-position]").forEach((listContainer) => {
    let fullWidthNumber = 0

    listContainer.querySelectorAll<HTMLElement>("[data-dynamic-width]").forEach((item) => {
      const lists = item.querySelectorAll("UL")
      lists.forEach((list) => {
        const nrChildren = list.children.length
        if (nrChildren) {
          //width-48  12rem
          //plus pl-1 0.25rem
          //plus pr-2 0.5rem
          //plus translate-2 0.5rem
          //13.25
          const calculatedwidth = 12 + 0.25 + 0.5 + 0.5
          const widthNumber = Math.ceil(nrChildren / 5) * calculatedwidth
          item.style.width = widthNumber.toString() + "rem"
          fullWidthNumber += widthNumber
        }
      })
    })
    //Check if the element is larger than just one column, move it to the left if it is.
    if (fullWidthNumber > 13.25) {
      listContainer.style.transform = `translateX(-` + fullWidthNumber / 4 + `rem)`
    }
  })
}
